import { render } from "./TheTableLoading.vue?vue&type=template&id=f64e9544&ts=true"
import script from "./TheTableLoading.vue?vue&type=script&lang=ts"
export * from "./TheTableLoading.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__